export default "__VITE_ASSET__Dht7YlWf__"